import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Players from "./components/Players";
import WhyElite from "./components/WhyElite";
import Testimonials from "./components/Testimonials";
import NewsCarousel from "./components/NewsCarousel";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import NewsPage from "./components/NewsPage";
import NewsDetail from "./components/NewsDetail";

const HomePage = () => {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Players />
      <WhyElite />
      <Testimonials />
      <NewsCarousel />
      <Contact />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Toaster position="top-right" richColors />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/noticias" element={<NewsPage />} />
          <Route path="/noticias/:slug" element={<NewsDetail />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
